import { render, staticRenderFns } from "./servicePay.vue?vue&type=template&id=beec20b4&scoped=true&"
import script from "./servicePay.vue?vue&type=script&lang=js&"
export * from "./servicePay.vue?vue&type=script&lang=js&"
import style0 from "./servicePay.vue?vue&type=style&index=0&id=beec20b4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beec20b4",
  null
  
)

export default component.exports